import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import autoTable from "jspdf-autotable";
import { Row, Col, Container } from "react-bootstrap";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { commonapisgsdp, gsdpReportexcel } from "../utils/commonFunctions";
import GsdpTable from "./GsdpTable";

export default function GsdpGrowthReport() {
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const [distlist, setDistrictList] = useState([]);
  const [mandallist, setMandalList] = useState();
  const [EntryData, setEntrydata] = useState();
  const [entrydataEnb, setEntrydataEnb] = useState(false);
  const [DistrictName, setDistrictName] = useState("");
  const [MandalName, setMandalname] = useState("");
  const [searchText, setSearch] = useState("");
  const [uniqueMandals, setuniqueMandals] = useState();
  const [uniqueDistricts, setuniqueDistricts] = useState();

  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();

  const years = Array.from({ length: 25 }, (_, index) => 23 + index);
  const initialGsdpEstimates = [
    years.reduce((acc, year) => {
      acc[`rps_${year}`] = "";
      acc[`percent_${year}`] = "";
      return acc;
    }, {}),
  ];
  const formik = useFormik({ initialValues: { district_id: "", mandal_id: "", Gsdp_estimates: initialGsdpEstimates } });
  useEffect(() => {
    commonapisgsdp(formik, roleid, setDistrictList, setMandalList, district);
  }, []);

  const gethodData = (e) => {
    let params = { userId: username, districtId: e.target.value };
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.gsdpgrowthReport(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);
          setEntrydata(res.data.SDESC);
          setuniqueDistricts([...new Set(res.data.SDESC.map((item) => item.district_id))]);
          const DistrictNames = {};
          res.data.SDESC.forEach((item) => {
            DistrictNames[item.district_id] = item.district_name;
          });
          setDistrictName(DistrictNames);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const getGsdpEstimates = (mandal) => {
    let params = {
      userId: username,
      districtId: district,
      mandalId: mandal,
    };
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.gsdpgrowthReport(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);
          setEntrydata(res.data.SDESC);
          setuniqueMandals([...new Set(res.data.SDESC.map((item) => item.mandal_id))]);
          const mandalNames = {};
          res.data.SDESC.forEach((item) => {
            mandalNames[item.mandal_id] = item.mandal_name;
          });
          setMandalname(mandalNames);
        } else {
          showAlertMessage(res.data.SDESC, "warning");
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const filteredData =
    searchText.length > 0 && EntryData?.length
      ? EntryData.filter((item) => {
          return (
            item &&
            Object.keys(item).some((key) => {
              const value = item[key];
              return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase());
            })
          );
        })
      : EntryData;

  return (
    <>
      <Menubar />
      <Container fluid className="map-header1">
        <div className="sa-title">
          <h2>
            GSDP <span> GROWTH REPORT</span>
          </h2>
        </div>
      </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4 mt-2">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="district_id" className="mb-1 fw-bold">
                    DISTRICT <span style={{ color: "red" }}>*</span>
                  </label>
                  <Field
                    id="district_id"
                    component="select"
                    name="district_id"
                    className="form-control"
                    disabled={roleid === "2"}
                    onChange={(e) => {
                      gethodData(e);
                      formik.handleChange(e);
                    }}
                  >
                    <option value="">--Select--</option>
                    <option value="0">ALL</option>
                    {distlist}
                  </Field>
                  <span style={{ color: "red", fontSize: "13px" }}>
                    <ErrorMessage name="district_id" />
                  </span>
                </Col>

                {roleid === "2" ? (
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col">
                    <label htmlFor="mandal_id" className="mb-1 fw-bold">
                      MANDAL
                    </label>
                    <span style={{ color: "red" }}> *</span>
                    <Field
                      component="select"
                      name="mandal_id"
                      className="form-control"
                      onChange={(e) => {
                        getGsdpEstimates(e.target.value);
                        formik.handleChange(e);
                      }}
                    >
                      <option value="">--Select--</option> <option value="0">ALL</option> {mandallist}
                    </Field>
                    <span style={{ color: "red", fontSize: "13px" }}>
                      <ErrorMessage name="mandal_id" />
                    </span>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>
            <br />
            {entrydataEnb && (
              <>
                <br />
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    <div id="search-box" style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} >
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchText}
                        onChange={(event) => setSearch(event.target.value)}
                        onFocus={() => {
                          const el = document.getElementById("search-box");
                          if (el) {
                            el.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
                            el.style.border = "1px solid #353935";
                            el.style.width = "100%";
                          }
                        }}
                        onBlur={() => {
                          const el = document.getElementById("search-box");
                          if (el) {
                            el.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                            el.style.border = "1px solid #ddd";
                            el.style.width = "150px";
                          }
                        }}
                        style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }}
                      />
                    </div>
                  </Col>
                  <Col className=" mb-2 ">
                    <button  size="sm" type="button" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => gsdpReportexcel("my-table", "GSDPGrowthReport")}>
                      Excel
                      <AiFillFileExcel style={{ fontSize: "18px" }} />
                    </button>
                  </Col>
                </Row>
                <GsdpTable formik={formik} roleid={roleid} DistrictNamee={DistrictName} MandalNamee={MandalName} uniqueMandalss={uniqueMandals} uniqueDistrictss={uniqueDistricts} filteredData={filteredData} yearss={years} table={"growth"} />
              </>
            )}
            <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
          </Form>
        </FormikProvider>
      </Container>
    </>
  );
}
